/*
* 管理marker
* 管理方式：
* 1.每添加一个marker，将对应的dom元素和配置项绑定到marker实例上，用于后续复制该marker；
* 2.每个marker都有一个id，可以重复，重复id的marker就一起处理
* 3.每个marker实例都存储到对应的map实例上，map实例上添加几个属性，作为存储marker用，
*  map实例添加多个属性存储marker是作为分类使用，一个属性作为一个marker分类，方便管理
* 4. 下面marker_store_name中存储的是marker的分类名称，如有增加，这里也要加，方便查询marker的时候用；
* */
import mapboxgl from "mapbox-gl"
let sys_markers_store = []/*主页地图marker存储*/
let sys_multi_scr_markers_store = []/*多屏地图marker存储*/
/*marker存储库的名字*/
let marker_store_name = ["common_marker", "measure_marker", "mearure_result","book_marker"]

/*获取vue实例*/
let get_main_vue = () => {
  return window.vue
}

/*添加marker*/
let add_marker = (lnglat, options_ori = {}) => {
  let map = options_ori.map || window.GLOBAL.common_store.sys_map;
  let res = add_marker_real(lnglat, options_ori)

  /*如果同步到所有地图*/
  if (options_ori.is_async) {
    let map_instance = []
    map_instance = window.GLOBAL.common_tool.get_all_map_instance({contain_main_map: true})
    map_instance.forEach(map_item => {
      /*和上面是一个地图实例的时候不处理，上面处理完了*/
      if (map_item.getContainer().id == map.getContainer().id) {
        return
      }
      let temp_options = JSON.parse(JSON.stringify(options_ori))
      temp_options.map = map_item
      add_marker_real(lnglat, temp_options)
    })
  }
  return res
}

/*实际添加marker*/
let add_marker_real = (lnglat, options_ori = {}) => {
  let options = {}
  Object.assign(options, options_ori)

  /*marker的dom*/
  let matker_dom = ''
  let popup = ""/*popup实例*/
  let popup_content = ""/*popup文字*/
  if (options.marker_type) {
    let factory_dom = get_marker_dom(options, lnglat)
    matker_dom = factory_dom.dom
    popup = factory_dom.popup
    popup_content = factory_dom.popup_content
    if (factory_dom.mark_option) {
      if (options.marker_option) {
        Object.assign(options.marker_option, factory_dom.mark_option)
      } else {
        options.marker_option = factory_dom.mark_option
      }
    }
  } else {
    matker_dom = options.dom
  }

  let map = options.map || window.GLOBAL.common_store.sys_map;
  let marker_id = options.marker_id || "sys_marker_id_" + Math.random() * 1000;

  let is_exit_res = map[options.marker_type] ? map[options.marker_type].filter(item => {
    return item.marker_id == marker_id
  }) : ''

  if (is_exit_res && is_exit_res.length > 0) {
    is_exit_res.forEach(item => {
      item.getElement().innerHTML = matker_dom.innerHTML
      item.setLngLat(lnglat)
      item.popup = popup
      item.popup_content = popup_content
      item.addTo(map)
    })
    return
  }

  /*最终的marker配置项*/
  let marker_option = options.marker_option || {}

  /*1.复制扩展项*/
  let copy_marker_options = JSON.parse(JSON.stringify(marker_option))
  /*2.复制dom*/
  let copy_marker_dom = $(matker_dom).clone()[0]

  /*实例化marker*/
  let cur_marker = new mapboxgl.Marker(matker_dom, marker_option)
    .setLngLat(lnglat)
    .addTo(map);


  /*记录id，源dom,源配置项*/
  cur_marker.marker_id = marker_id/*主id*/

  /*处理popup*/
  if(popup){
    popup.popup_id = marker_id/*绑定与宿主marker一样的id*/
    cur_marker.popup = popup
    cur_marker.popup_content = popup_content

    /*刷新marker对应的popup*/
    cur_marker.refresh_popup = function (content){
      if(this.popup){
        let html = "<div style='padding: 5px 10px;'>" + content + "</div>"
        this.popup.setHTML(html)
        this.popup.addTo(this._map)
        this.popup_content = content
      }
    }

    /*点击marker，弹出marker对应的popup*/
    matker_dom.marker = cur_marker
    matker_dom.addEventListener('click', function () {
      if(this.marker && this.marker.popup){
        this.marker.popup.addTo(this.marker._map)
      }
    });

  }

  /*副id（一般是测量工具显示测量结果的marker使用）*/
  if (options.deputy_marker_id) {
    cur_marker.deputy_marker_id = options.deputy_marker_id
    if(popup){
      popup.deputy_marker_id = options.deputy_marker_id
    }
  }
  cur_marker.ori_dom = copy_marker_dom
  cur_marker.ori_options = copy_marker_options

  /*各个marker存储到map实例上，通过挂接map上的某属性，用数组存储，
  * 这个某属性是多个，叫做marker_type,也就是将marker分类存储，方便管理
  * 如果没有知道分类名称即options.marker_type,就是用默认的marker分组名称即common_marker
  * */
  let marker_type_name = options.marker_type ? options.marker_type : 'common_marker'
  if (map[marker_type_name]) {
    map[marker_type_name].push(cur_marker)
  } else {
    map[marker_type_name] = [cur_marker]
  }
  cur_marker.marker_type = marker_type_name

  return cur_marker
}

/*删除测量工具用于显示测量结果的marker*/
let del_measure_marker = (marker_id, options_ori = {}) => {

  let map = options_ori.map || window.GLOBAL.common_store.sys_map;
  let marker_ids = marker_id instanceof Array ? marker_id : [marker_id]

  /*找到最终要删除的marker_id*/
  let final_del_marker_ids = []
  marker_ids.forEach(marker_id_item => {
    if (map["mearure_result"]) {
      let temp_del_marker = map["mearure_result"].filter(item => {
        return item.deputy_marker_id == marker_id_item
      })

      temp_del_marker.forEach(temp_marker_item => {
        final_del_marker_ids.push(temp_marker_item.marker_id)
      })
    }
  })
  options_ori.marker_type = "mearure_result"

  del_marker(final_del_marker_ids, options_ori)
}

/*删除marker*/
let del_marker = (marker_id, options_ori = {}) => {
  let map = options_ori.map || window.GLOBAL.common_store.sys_map;
  del_marker_real(marker_id, options_ori)

  /*是否同步到所有地图*/
  if (options_ori.is_async) {
    let map_instance = []
    map_instance = window.GLOBAL.common_tool.get_all_map_instance({contain_main_map: true})
    map_instance.forEach(map_item => {
      /*和上面是一个地图实例的时候不处理，上面处理完了*/
      if (map_item.getContainer().id == map.getContainer().id) {
        return
      }
      let temp_options = JSON.parse(JSON.stringify(options_ori))
      temp_options.map = map_item
      del_marker_real(marker_id, options_ori)
    })
  }
}

/*删除marker*/
let del_marker_real = (marker_id, options_ori = {}) => {
  let options = {is_save: true}
  Object.assign(options, options_ori)
  let map = options.map || window.GLOBAL.common_store.sys_map;
  let marker_type_name = options.marker_type ? options.marker_type : 'common_marker'

  let marker_ids = []
  if (marker_id instanceof Array) {
    marker_ids = marker_id
  } else {
    marker_ids = [marker_id]
  }

  /*找到对应的marker*/
  if (map[marker_type_name]) {
    let res = []
    map[marker_type_name].forEach(item => {
      if (marker_ids.includes(item.marker_id)) {
        if(item.popup){item.popup.remove()}
        item.remove()
      } else {
        res.push(item)
      }
    })
    map[marker_type_name] = res;
  }
}

/**
 * 全部删除marker
 * @param type marker类型，不传就全删，传就删除对应类型的marker
 */
let del_marker_all = (options = {}) => {
  let map = options.map
  /*有map删除对应的map的所有marker,没有map则删除所有map的marker*/
  if (map) {
    del_marker_all_real(options)
  } else {
    let map_instance = window.GLOBAL.common_tool.get_all_map_instance({contain_main_map: true})
    map_instance.forEach(item_map => {
      del_marker_all_real({map: item_map})
    })
  }
}

/**
 * 全部删除marker
 * @param type marker类型，不传就全删，传就删除对应类型的marker
 */
let del_marker_all_real = (options = {}) => {
  let map = options.map || window.GLOBAL.common_store.sys_map;
  marker_store_name.forEach(store_name => {
    if (map[store_name]) {
      map[store_name].forEach(marker_item => {
        marker_item.remove()
      })
      map[store_name] = []
    }
  })
}

/*获取marker*/
let get_marker = (marker_id, options_ori = {}) => {
  let options = {}
  Object.assign(options, options_ori);
  let map = options.map || window.GLOBAL.common_store.sys_map;

  let res = []
  marker_store_name.forEach(store_name => {
    if (map[store_name]) {
      res = res.concat(map[store_name].filter(item => {
        return item.marker_id == marker_id
      }))
    }
  })
  return res
}

/*根据不同类型，获取对应的marker显示的dom*/
let get_marker_dom = (option, lnglat = []) => {
  /*二维测量显示结果的marker*/
  if (option.marker_type == "measure") {
    return create_measure_marker_dom(option.content)
  }

  /*二维绘制点图形显示结果的marker*/
  if (option.marker_type == "draw_point") {
    return create_draw_point_marker(option)
  }

  /*二维绘制非点图形显示名称的marker*/
  if (option.marker_type == "draw_common") {
    return create_draw_label_marker(option.content)
  }

  if (option.marker_type == "book_marker") {
    return create_book_marker(option, lnglat)
  }

  /*测量工具的测量结果，实时的marker（实时面积，实时长度，实时位置）*/
  if (option.marker_type == "mearure_result") {
    if (option.measure_point) {
      return create_mearure_result_marker_point(option.content)
    }
    return create_mearure_result_marker(option.content)
  }
}

/*创建书签marker*/
let create_book_marker = (option, lnglat) => {

  /*marker要显示的内容*/
  let el_div = document.createElement('div');
  el_div.style.position = 'reletive'
  /*实例化标签名称*/
  let el_div1 = document.createElement('div');
  el_div1.className = "sys_bookmarker_icon"


  //popup显示内容
  let popupHtml = "<div style='padding: 5px 10px;'>" + option.content + "</div>";

  let map = option.map || window.GLOBAL.common_store.sys_map

  let popup = new  mapboxgl.Popup({offset: [0, -58, 0],className:'sys_bookmarker_popup',closeOnClick:false})
    .setLngLat(lnglat)
    .setHTML(popupHtml)
    .addTo(map);

  $(el_div).append(el_div1)

  return {
    dom: el_div,
    mark_option: {offset: [0, -29, 0]},
    popup:popup,
    popup_content:option.content
  }
}

/*创建测量点的结果的marker*/
let create_mearure_result_marker_point = (option) => {

  let lnglat = option.lnglat

  /*marker要显示的内容*/
  let el_div = document.createElement('div');
  el_div.style.position = 'reletive'

  let lng = lnglat[0].toFixed(4)
  let lat = lnglat[1].toFixed(4)

  /*实例化标签名称*/
  let el_div1 = document.createElement('div');
  el_div1.innerHTML = `<span>经度:${lng}</span><br><span>纬度:${lat}</span>`
  el_div1.style.backgroundColor = "rgba(0,0,0,0.2)";
  el_div1.style.color = "#fff";
  el_div1.style.textAlign = "left";
  el_div1.style.padding = "2px";
  el_div1.style.fontSize = "14px";
  el_div1.style.textAlign = "center";
  el_div1.style.display = 'block';
  el_div1.style.position = "absolute";
  let el_div1_width = ((lng > lat ? lng : lat).length + 3) * 10 + 3
  el_div1.style.width = el_div1_width + 'px';
  $(el_div).append(el_div1)
  return {
    dom: el_div,
    mark_option: {offset: [-(el_div1_width / 2), 0]}
  }
}

/*测量工具的测量结果marker*/
let create_mearure_result_marker = (content = "") => {
  /*marker要显示的内容*/
  let el_div = document.createElement('div');
  el_div.style.position = 'reletive'

  /*实例化标签名称*/
  let el_span = document.createElement('span');
  el_span.innerText = content
  el_span.style.backgroundColor = "rgba(0,0,0,0.2)";
  el_span.style.color = "#fff";
  el_span.style.padding = "2px";
  el_span.style.fontSize = "14px";
  el_span.style.textAlign = "center";
  el_span.style.display = 'block';
  el_span.style.position = "absolute";
  let span_width = el_span.innerText.length * 10 + 3
  el_span.style.width = span_width + 'px';

  $(el_div).append(el_span)

  return {
    dom: el_div,
    mark_option: {offset: [-(span_width / 2), 0]}
  }
}

/*给二维测量结果的marker创建dom*/
let create_measure_marker_dom = (content = "") => {
  /*marker要显示的内容*/
  let el_div = document.createElement('div');
  el_div.style.position = 'reletive'

  /*实例化标签名称*/
  let el_span = document.createElement('span');
  el_span.innerText = content
  el_span.style.backgroundColor = "rgba(0,0,0,0.2)";
  el_span.style.color = "#fff";
  el_span.style.padding = "2px";
  el_span.style.fontSize = "14px";
  el_span.style.textAlign = "center";
  el_span.style.display = 'block';
  el_span.style.position = "absolute";
  let span_width = el_span.innerText.length * 10 + 3
  el_span.style.width = span_width + 'px';

  $(el_div).append(el_span)

  return {
    dom: el_div,
    mark_option: {offset: [-(span_width / 2), 0]}
  }
}

/*创建二维绘制点图形的marker的dom*/
let create_draw_point_marker = ({iconName, iconSize, color, isLabelShow, text}) => {


  /*marker要显示的内容*/
  let el_div = document.createElement('div');

  let el_i = document.createElement('i');
  el_i.style.display = 'block';
  el_i.className = "iconfont " + iconName;
  el_i.style.color = color;
  el_i.style.fontSize = iconSize + 'px';
  el_i.style.position = "reletive";
  $(el_div).append(el_i)

  /*实例化符号*/
  if (isLabelShow && text) {
    /*实例化标签名称*/
    let el_span = document.createElement('span');
    el_span.innerText = text
    el_span.style.backgroundColor = "#393B37";
    el_span.style.padding = "2px";
    el_span.style.color = "#fff";
    el_span.style.fontSize = "14px";
    el_span.style.display = 'block';
    el_span.style.textAlign = "center";
    el_span.style.position = "absolute";
    el_span.style.bottom = '-' + (parseFloat(iconSize) / 2 + 16) + "px";
    let span_width = el_span.innerText.length * 16 + 6
    el_span.style.width = span_width + 'px';
    if (span_width >= parseFloat(iconSize)) {
      el_span.style.left = "-" + (((el_span.innerText.length * 18) / 2 - 14)) + 'px';
    } else {
      el_span.style.left = (parseFloat(iconSize) - span_width) / 2 + "px"
    }
    $(el_div).append(el_span)
  }

  return {
    dom: el_div
  }
}

/*给二维测量结果的marker创建dom*/
let create_draw_label_marker = (content = "") => {

  let el_span = document.createElement('span');
  el_span.innerText = content
  el_span.style.backgroundColor = "#393B37";
  el_span.style.color = "#fff";
  el_span.style.padding = "3px";
  el_span.style.fontSize = "14px";

  return {dom: el_span}
}

/*回显marker*/
let review_marker = (options) => {

  let from_map = options.from_map/*marker源*/
  let to_map = options.to_map/*需要回显marker的map实例*/

  let to_map_instances = []
  if (to_map instanceof Array) {
    to_map_instances = to_map
  } else {
    to_map_instances = [to_map]
  }

  let cur_marker_store_name = options.marker_store_name || marker_store_name
  to_map_instances.forEach(item_map => {
    cur_marker_store_name.forEach(item_store_name => {
      if (from_map[item_store_name]) {
        from_map[item_store_name].forEach(marker_item => {
          let temp_options = ''
          temp_options.map = item_map
          temp_options.marker_id = marker_item.marker_id
          temp_options.dom = marker_item.ori_dom
          temp_options.marker_option = marker_item.ori_options
          add_marker_real([marker_item.getLngLat().lng,
            marker_item.getLngLat().lat], temp_options)
        })
      }
    })
  })


}

export default {
  add_marker,
  del_marker,
  del_marker_all,
  get_marker,
  review_marker,
  del_measure_marker
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/sys_makrer_tool.js